import {
  type CommonTranslationFunction,
  type GeneralCommonPaths,
} from '@autone/translations';

import {
  type NavigationItem,
  type SidebarSubNavigationItemProps,
} from '../types/Sidebar.types';

import { getIsActive } from './getIsActive';

/**
 * Creates a sidebar sub-item from configuration parameters
 * @param subItemConfig - Configuration for the sub-item
 * @param common - Translation function to get localized strings
 * @param currentPathname - Current route pathname for active state detection
 * @param withClientRouting - Function to handle client-side routing
 * @returns Configured sidebar sub-item
 */
export const createSidebarSubItem = ({
  subItemConfig,
  common,
  currentPathname,
  withClientRouting,
}: {
  subItemConfig: { titleKey: GeneralCommonPaths; path: string };
  common: CommonTranslationFunction;
  currentPathname: string;
  withClientRouting: (path: string) => NavigationItem;
}): SidebarSubNavigationItemProps => {
  return {
    title: common(subItemConfig.titleKey),
    ...withClientRouting(subItemConfig.path),
    isActive: getIsActive({
      href: subItemConfig.path,
      path: subItemConfig.path,
      currentPathname,
    }),
    isDisabled: false,
  };
};
